<template>
  <div class="space-y-1 text-[14px]">
    <div :class="{ 'flex justify-between': isDesktop }">
      <p class="text-grey-light-700" :class="{ 'font-bold': !isDesktop }">Product Name</p>
      <p class="text-grey-light-900">{{ name }}</p>
    </div>
    <div :class="{ 'flex justify-between': isDesktop }">
      <p class="text-grey-light-700" :class="{ 'font-bold': !isDesktop }">Reference</p>
      <p class="text-grey-light-900">{{ reference }}</p>
    </div>
    <div :class="{ 'flex justify-between': isDesktop }">
      <p class="text-grey-light-700" :class="{ 'font-bold': !isDesktop }">Reason</p>
      <p class="text-grey-light-900 max-w-[250px] truncate">{{ reason }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useBreakpoint } from '@/utils/useBreakPoint';

const { isDesktop } = useBreakpoint();

defineProps<{
  name: string;
  reference: string;
  reason: string;
}>();
</script>
